module.exports = __webpack_public_path__ + "9ab772b95886f628c9ef1b0790bc37f4.svg";